<template>
  <a-modal
    title="请选择需要禁用的小组和讲次"
    centered
    :width="1100"
    :visible="visible"
    :mask-closable="false"
    :footer="null"
    @cancel="handleCancel"
  >
    <a-table
      row-key="id"
      :scroll="scroll"
      :loading="loading"
      :columns="columns"
      :data-source="tableData"
      :pagination="false"
    >
      <!-- eslint-disable-next-line vue/no-unused-vars -->
      <template slot="speedDisabled" slot-scope="text, record">
        <span class="spot" :style="{background: text === 1 ? '#FF5C5C' : '#06C270'}" />
        <span :class="[text === 1 ? 'pause' : 'play']">
          {{ text === 1 ? '已禁用' : '未禁用' }}
        </span>
      </template>

      <div slot="action" slot-scope="text, record">
        <a-button type="link" v-if="record.speedDisabled === 0" @click="pause(record)">
          禁用
        </a-button>
        <a-button v-else type="link" @click="play(record)">
          恢复
        </a-button>
      </div>
    </a-table>
  </a-modal>
</template>

<script>

// 小组列表
const columns = [
  {
    dataIndex: 'groupName',
    key: 'groupName',
    title: '小组名称',
    ellipsis: true,
    align: 'left',
    scopedSlots: { customRender: 'groupName' }
  },
  {
    dataIndex: 'lessonName',
    key: 'lessonName',
    ellipsis: true,
    align: 'left',
    title: '讲次信息',
    customRender: (text, row) => `第${row.lessonNum}讲  ${row.lessonName}`
  },
  {
    dataIndex: 'studentNum',
    key: 'studentNum',
    align: 'left',
    title: '小组人数',
    scopedSlots: { customRender: 'studentNum' }
  },
  {
    dataIndex: 'speedDisabled',
    key: 'speedDisabled',
    align: 'left',
    title: '状态',
    scopedSlots: { customRender: 'speedDisabled' }
  },
  {
    title: '操作',
    align: 'center',
    width: 180,
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    groupArr: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      modalConfirmLoading: false,
      currentRow: null, // 当前操作行
      scroll: {
        x: 760,
        y: 'calc(100vh - 254px - 145px)'
      },
      loading: false,
      tableData: [], // 我的小组列表
      columns
    }
  },

  watch: {
    visible: {
      handler(nV) {
        // eslint-disable-next-line no-empty
        if (nV) {
          this.initList()
        }
      },
      immediate: true
    }
  },

  methods: {
    initList() {
      const arr = (this.groupArr || []).filter(k => k.currentBehavior && [1, 2, 3].includes(k.currentBehavior.type)).map(k => ({
        xkhTeacherCourseId: k.xkhTeacherCourseId,
        lessonId: k.lessonId
      }))

      this.loading = true
      this.$service.supervision.speedConfigList({ groupLessonList: arr }).then(res => {
        this.loading = false
        this.tableData = res || []
      }).catch(err => {
        this.loading = false
      })
    },

    play(row) {
      this.currentRow = row
      this.$confirm({
        content: () => <div>确认恢复该讲次倍速吗？</div>,
        confirmLoading: this.modalConfirmLoading,
        centered: true,
        // 展示不下时，需要加滚动条
        onOk: () => this.handlePlay(),
        cancelText: '取消'
      })
    },

    handlePlay() {
      const _this = this
      this.modalConfirmLoading = true
      const { xkhTeacherLessonId } = this.currentRow
      return new Promise((resolve, reject) => {
        this.$service.supervision.setSpeedState({
          id: xkhTeacherLessonId, // 小组讲次主键Id
          status: 0 // 0继续，1暂停
        }).then(res => {
          _this.modalConfirmLoading = false
          this.initList() // 列表更新
          resolve()
        }).catch(err => {
          _this.modalConfirmLoading = false
          // eslint-disable-next-line prefer-promise-reject-errors
          reject()
        }).finally(() => {
          _this.modalConfirmLoading = false
        })
      })
    },

    handlerPause() {
      const _this = this
      this.modalConfirmLoading = true
      const { xkhTeacherLessonId } = this.currentRow
      return new Promise((resolve, reject) => {
        this.$service.supervision.setSpeedState({
          id: xkhTeacherLessonId, // 小组讲次主键Id
          status: 1 // 0继续，1暂停
        }).then(res => {
          _this.modalConfirmLoading = false
          // const { xkhTeacherCourseId, lessonId, aiLessonId } = this.currentRow
          // supervisionLogger.pauseLogger({
          //   groupId: xkhTeacherCourseId,
          //   lessonId,
          //   aiLessonId
          // })
          this.initList() // 列表更新
          resolve()
        }).catch(err => {
          _this.modalConfirmLoading = false
          // eslint-disable-next-line prefer-promise-reject-errors
          reject()
        }).finally(() => {
          _this.modalConfirmLoading = false
        })
      })
    },

    pause(row) {
      this.currentRow = row
      this.$confirm({
        content: () => <div>您确认禁用该讲次倍速吗？</div>,
        confirmLoading: this.modalConfirmLoading,
        centered: true,
        // 展示不下时，需要加滚动条
        onOk: () => this.handlerPause(),
        cancelText: '取消'
      })
    },

    handleCancel() {
      this.$emit('update:visible', false)
    },
    onOK() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/static/css/base.less';
:deep(.ant-table-fixed-header .ant-table-scroll .ant-table-header) {
  overflow: overlay !important;
  padding-bottom: 15px !important;
}
.spot {
  display: inline-block;
  width: 4px;
  height: 4px;
  position: relative;
  top: -3px;
  border-radius: 1px;
  transform: rotate(45deg);
}
.play {
  color: #303858;
}
.pause {
  color: #FF5C5C;
}
</style>